import Navigo from 'navigo';
import {
  authRoute,
  canvasRoute,
  howtoRoute,
  loaderRoute,
  loginRoute,
  logoutRoute,
  mainRoute,
  ofcAccessRoute,
  removebgRoute,
  subscriptionRoute,
  templateManagerRoute,
  projectsRoute,
} from './routes';

export const router = new Navigo();

export const initRouter = () => {
  router
    .on('/', mainRoute)
    .on('/auth', authRoute)
    .on('/accesso-ofc', ofcAccessRoute)
    .on('/start', loaderRoute)
    .on('/canvas', canvasRoute)
    .on('/canvas/:id', canvasRoute)
    .on('/template-manager', templateManagerRoute)
    .on('/template-manager/:id', templateManagerRoute)
    .on('/how-to', howtoRoute)
    .on('/subscription', subscriptionRoute)
    .on('/login', loginRoute)
    .on('/logout', logoutRoute)
    .on('/credits', removebgRoute)
    .on('/projects', projectsRoute)
    .resolve();
};
